import { useAuth } from "../auth/AuthProvider";
import { brandingForHost, type Branding } from "../config";

/**
 * The tenant's name and mark for the host the SPA is served on (TEN-04):
 * the name from /v1/me once it has answered, else config.json's per-host
 * value, else the build's default — never a literal in code (ADR-0008).
 */
export function useBranding(): Branding {
  const { config, me } = useAuth();
  const host = brandingForHost(config);
  return me?.tenant.productName ? { ...host, productName: me.tenant.productName } : host;
}

/**
 * The logo: the tenant's mark with the product name beside it (the full
 * logo), or the mark alone (the abbreviated one — the collapsed rail, a
 * square slot). The mark is decorative; the name is the text. Without a
 * mark for this host, the name alone.
 */
export function Logo({ branding, abbreviated = false, size = "md", className = "" }: { branding: Branding; abbreviated?: boolean; size?: "md" | "lg"; className?: string }) {
  const mark = size === "lg" ? "size-10" : "size-7";
  const text = size === "lg" ? "text-2xl font-semibold tracking-tight" : "text-lg font-semibold";
  return (
    <span className={`inline-flex items-center gap-3 text-ink ${className}`}>
      {branding.mark && <img src={branding.mark} alt="" aria-hidden="true" className={`${mark} shrink-0`} />}
      {abbreviated ? <span className="sr-only">{branding.productName}</span> : <span className={`min-w-0 truncate ${text}`}>{branding.productName}</span>}
    </span>
  );
}
